(function(){
  const root=document.querySelector("[data-cam]"); if(!root) return;
  const $=s=>root.querySelector(s);
  const ID=root.dataset.mt;
  const DATA=(()=>{const b=atob(root.dataset.k),u=new Uint8Array(b.length);for(let i=0;i<b.length;i++)u[i]=b.charCodeAt(i);return JSON.parse(new TextDecoder().decode(u))})();
  const S=DATA.S.map(([h,team,season,kit,retro,extra])=>({h,team,season,kit,retro:!!retro,extra}));
  const norm=s=>String(s||"").normalize("NFD").replace(/[̀-ͯ]/g,"").toLowerCase();
  const esc=s=>String(s).replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
  const store={get(k){try{return JSON.parse(localStorage.getItem(k))}catch(e){return null}},set(k,v){try{localStorage.setItem(k,JSON.stringify(v))}catch(e){}}};
  const MAX=5, PX=[8,12,18,28,46];
  const todayKey=new Intl.DateTimeFormat("en-CA",{timeZone:"Europe/Madrid",year:"numeric",month:"2-digit",day:"2-digit"}).format(new Date());
  const dayIdx=Math.max(0,Math.round((new Date(todayKey+"T12:00:00Z")-new Date(DATA.L+"T12:00:00Z"))/864e5));
  const KEY="cam-d"+todayKey;
  const RM=window.matchMedia&&matchMedia("(prefers-reduced-motion: reduce)").matches;
  const q=$("[data-q]"), sugg=$("[data-sugg]"), modal=$("[data-modal]"), mbody=$("[data-mbody]");
  let mode="daily", target, state, opts=[], sel=0, lastFocus=null;

  $("[data-week]").textContent="Jornada "+(dayIdx+1);
  $("[data-date]").textContent=new Intl.DateTimeFormat("es-ES",{weekday:"long",day:"numeric",month:"long",timeZone:"Europe/Madrid"}).format(new Date());

  /* Producto: foto y título reales desde la tienda */
  const cache={};
  function getProduct(h){if(!cache[h])cache[h]=fetch(`/products/${encodeURIComponent(h)}.js`).then(r=>r.ok?r.json():null).catch(()=>null);return cache[h]}
  function withProduct(t){return getProduct(t.h).then(p=>{if(p){let i=p.featured_image||"";if(i.startsWith("//"))i="https:"+i;t.img=i;t.title=p.title;t.price=p.price/100}return t})}

  function load(){
    target=S[dayIdx%S.length];
    const saved=store.get(KEY);
    state=(saved&&Array.isArray(saved.g))?saved:{g:[],teamOk:false,pick:null,done:false,claimed:false};
    render();withProduct(target).then(()=>showImage());
    const nx=S[(dayIdx+1)%S.length];getProduct(nx.h);
  }
  function save(){ if(mode==="daily") store.set(KEY,state); }

  const label=t=>t.retro?`${t.team} ${t.season}`:(t.season.includes("Mundial")?`${t.team} ${t.season} · ${t.kit}`:`${t.team} ${t.season} · ${t.kit}`);
  const answer2=t=>t.retro?t.season:t.kit;

  /* Segundo paso: temporada (retro) o equipación (actual) */
  function seasonLabel(y,club){return club?`${y}/${String((y+1)%100).padStart(2,"0")}`:String(y)}
  function options2(t){
    if(!t.retro) return t.season.includes("Mundial")?["Primera","Segunda"]:["Primera","Segunda","Tercera"];
    const club=t.season.includes("/"), y=parseInt(t.season,10);
    const pool=(club?[-4,-2,2,4,-6,6]:[-8,-4,4,8,-12,12]).map(o=>y+o).filter(v=>v<=2024);
    let seed=0;for(const ch of t.h)seed=(seed*31+ch.charCodeAt(0))>>>0;
    const picks=[];while(picks.length<3&&pool.length){picks.push(pool.splice(seed%pool.length,1)[0]);seed=(seed*1103515245+12345)>>>0}
    return [t.season,...picks.map(v=>seasonLabel(v,club))].sort((a,b)=>parseInt(a,10)-parseInt(b,10));
  }
  function hints(t){
    const info=DATA.I[t.team]||["",""];
    let epoca;
    if(t.retro){const y=parseInt(t.season,10),dec=Math.floor(y/10)*10;epoca=(dec<2000?`Retro · años ${String(dec).slice(2)}`:`Retro · años ${dec}`)+(t.extra?` · ${t.extra}`:"")}
    else epoca=t.season.includes("Mundial")?"Actual · Mundial 2026":"Actual · temporada 2026/27";
    const n=t.team.replace(/[^A-Za-zÀ-ÿ]/g,"").length;
    return [["Tipo",info[0]],["Época",epoca],["Ciudad",info[1]],["Inicial",`Empieza por «${t.team[0]}» · ${n} letras`]];
  }

  /* Imagen pixelada con el CDN de Shopify */
  function imgUrl(src,w){return src+(src.includes("?")?"&":"?")+`width=${w}&height=${w}&crop=center`}
  function showImage(){
    const ph=$("[data-photo]"), img=$("[data-img]"), z=$("[data-zoom]");
    if(!target.img){z.hidden=false;z.textContent="Cargando…";return}
    const wrong=state.g.filter(n=>n!==target.team).length;
    if(state.done){ph.classList.remove("px");img.src=imgUrl(target.img,800);img.alt=`Camiseta ${label(target)}`;z.hidden=true;return}
    const step=state.teamOk?PX.length-1:Math.min(wrong,PX.length-1);
    ph.classList.add("px");img.src=imgUrl(target.img,PX[step]);img.alt="Camiseta misteriosa";
    z.hidden=false;z.textContent=["Muy pixelada","Pixelada","Se intuye algo","Casi","Bastante clara"][step];
    const pre=new Image();pre.src=imgUrl(target.img,PX[Math.min(step+1,PX.length-1)]);
  }

  /* Buscador de equipos */
  const TEAMS=DATA.T.map(n=>({n,a:DATA.A[n]||""}));
  function showSugg(){
    const v=norm(q.value.trim()), used=new Set(state.g);
    opts=v?TEAMS.filter(t=>!used.has(t.n)&&(norm(t.n).includes(v)||norm(t.a).includes(v))).slice(0,8):[];
    sel=0;
    sugg.innerHTML=opts.map((t,i)=>`<li role="option" data-i="${i}" aria-selected="${i===sel}">${esc(t.n)}${t.a&&!norm(t.n).includes(v)?`<small>${esc(t.a)}</small>`:""}</li>`).join("");
    sugg.hidden=!opts.length;q.setAttribute("aria-expanded",String(!!opts.length));
  }
  q.addEventListener("input",showSugg);
  q.addEventListener("keydown",e=>{
    if(sugg.hidden)return;
    if(e.key==="ArrowDown"||e.key==="ArrowUp"){e.preventDefault();sel=(sel+(e.key==="ArrowDown"?1:-1)+opts.length)%opts.length;[...sugg.children].forEach((li,i)=>li.setAttribute("aria-selected",i===sel))}
    if(e.key==="Enter"){e.preventDefault();guess(opts[sel])}
    if(e.key==="Escape"){sugg.hidden=true}
  });
  sugg.addEventListener("mousedown",e=>{const li=e.target.closest("li");if(li){e.preventDefault();guess(opts[+li.dataset.i])}});
  document.addEventListener("click",e=>{if(!e.target.closest(".cam__search"))sugg.hidden=true});

  function guess(t){
    if(!t||state.done||state.teamOk)return;
    state.g.push(t.n);q.value="";sugg.hidden=true;
    if(t.n===target.team){state.teamOk=true}
    else if(state.g.length>=MAX){state.done=true}
    save();render();
    if(state.done) setTimeout(openModal,RM?200:900);
    else if(!state.teamOk) q.focus();
    else { const b=root.querySelector("[data-seasons] button"); if(b) b.focus(); }
  }
  function pick2(s){
    if(state.done||!state.teamOk)return;
    state.pick=s;state.done=true;save();render();
    setTimeout(openModal,RM?200:1100);
  }

  function renderLights(){
    const used=state.g.length, won=state.teamOk;
    $("[data-lights]").innerHTML="Intentos "+Array.from({length:MAX},(_,i)=>`<i class="${i<used?"used":""}${won&&i===used-1?" won":""}"></i>`).join("");
  }
  function render(){
    renderLights();showImage();
    const wrong=state.g.filter(n=>n!==target.team).length;
    $("[data-fails]").innerHTML=state.g.map(n=>`<span class="${n===target.team?"ok":""}">${n===target.team?"✓":"✗"} ${esc(n)}</span>`).join("");
    const H=hints(target), shown=state.done?H.length:Math.min(wrong,H.length);
    $("[data-hints]").innerHTML=H.map((h,i)=>i<shown?`<li><small>${h[0]}</small>${esc(h[1])}</li>`:`<li class="locked"><small>${h[0]}</small>Se desbloquea al fallar ${i+1}</li>`).join("");
    $("[data-step1]").hidden=state.teamOk;
    q.disabled=state.done;
    q.placeholder=state.done?(mode==="daily"?"Vuelve mañana para una camiseta nueva":"Partida terminada"):"Escribe un club o una selección…";
    const s2=$("[data-step2]");
    s2.hidden=!state.teamOk;
    if(state.teamOk){
      const ask=target.retro?"¿Te atreves con la temporada?":"¿Sabes qué equipación es?";
      $("[data-step2txt]").innerHTML=state.done?`Era la <b>${esc(label(target))}</b>.`:`¡Es del <b>${esc(target.team)}</b>! Ya sumas un 5%. ${ask} Solo hay un intento.`;
      const opts2=options2(target);
      $("[data-seasons]").innerHTML=opts2.map(s=>{
        let cls="";if(state.pick){if(s===answer2(target))cls="ok";else if(s===state.pick)cls="no"}
        return `<button type="button" class="${cls}" ${state.pick?"disabled":""} data-s="${esc(s)}">${esc(s)}</button>`}).join("");
      root.querySelectorAll("[data-seasons] button").forEach(b=>b.addEventListener("click",()=>pick2(b.dataset.s)));
    }
    renderResult();
  }
  const pleno=()=>state.teamOk&&state.pick===answer2(target);
  function shareText(){
    const row=state.g.map(n=>n===target.team?"🟩":"🟥").join("")+(pleno()?"⭐":"");
    return `Adivina la camiseta · Jornada ${dayIdx+1} · ${state.teamOk?state.g.length:"X"}/${MAX}\n${row}\n${location.origin}${location.pathname}`;
  }

  /* Tienda: relacionadas */
  const money=n=>Number(n).toFixed(2).replace(".",",")+" €";
  function searchShop(qs){
    return fetch(`/search/suggest.json?q=${encodeURIComponent(qs)}&resources[type]=product&resources[limit]=10&resources[options][fields]=title&resources[options][unavailable_products]=hide`)
      .then(r=>r.ok?r.json():null).then(j=>(j&&j.resources&&j.resources.results&&j.resources.results.products)||[]).catch(()=>[]);
  }
  const kitKey=t=>norm(t).replace(/\s*(version|manga larga).*$/,"").trim();
  function cardHTML(p){
    let img=p.image||"";if(img){img=(img.startsWith("//")?"https:"+img:img);img+=(img.includes("?")?"&":"?")+"width=360";}
    const url=String(p.url||("/products/"+p.handle)).split("?")[0];
    return `<a class="cam__card" href="${esc(url)}"><span class="cam__img">${img?`<img src="${esc(img)}" alt="" loading="lazy" width="360" height="360">`:""}</span><span class="cam__ptitle">${esc(p.title)}</span><span class="cam__price">${money(p.price)}</span></a>`;
  }
  function heroHTML(){
    const t=target;
    return `<div class="cam__hero">${t.img?`<img src="${esc(imgUrl(t.img,400))}" alt="">`:""}<div><strong>${esc(t.title||label(t))}</strong><span class="cam__price">${t.price?money(t.price):""}</span><a class="cam__btn" href="/products/${encodeURIComponent(t.h)}">Ver la camiseta</a></div></div>`;
  }
  function relatedHTML(){
    const t=target, gid="r"+Math.random().toString(36).slice(2,8), must=norm(t.team);
    const qs=t.retro?"retro "+t.team:t.team+" fan";
    searchShop(qs).then(list=>{
      const el=document.getElementById(gid);if(!el)return;
      const seen=new Set([kitKey(t.title||"")]),out=[];
      for(const p of list){if(p.handle===t.h||!norm(p.title).includes(must))continue;if(/nino|mujer|bebe/.test(norm(p.title)))continue;const k=kitKey(p.title);if(seen.has(k))continue;seen.add(k);out.push(p);if(out.length>=4)break}
      if(!out.length){el.parentNode.remove();return}
      el.innerHTML=out.map(cardHTML).join("");
    });
    return `<div class="cam__rel"><h3 class="cam__relh">Más camisetas${t.retro?" retro":""} del ${esc(t.team)}</h3><div class="cam__grid" id="${gid}"><p class="cam__note">Buscando camisetas…</p></div></div>`;
  }

  function openModal(){lastFocus=document.activeElement;renderModal();modal.hidden=false;document.documentElement.style.overflow="hidden";setTimeout(()=>$("[data-close]").focus(),30)}
  function closeModal(){modal.hidden=true;document.documentElement.style.overflow="";if(lastFocus&&lastFocus.focus)lastFocus.focus()}
  $("[data-close]").addEventListener("click",closeModal);
  modal.addEventListener("click",e=>{if(e.target===modal)closeModal()});
  document.addEventListener("keydown",e=>{if(e.key==="Escape"&&!modal.hidden)closeModal()});

  function renderModal(){
    let top;const n=state.g.length;const extra2=target.retro?"y temporada":"y equipación";const J=window.CortitaJuegos;
    if(state.teamOk&&mode==="daily"){
      top=`<p class="cam__meyebrow">Equipo acertado en ${n} ${n===1?"intento":"intentos"}${pleno()?` · ${extra2} ⭐`:""}</p><h2 id="${ID}">${pleno()?"¡Pleno!":"¡Golazo!"} ${esc(label(target))}</h2>`+(J?J.prizeBox("camiseta",true):"");
    } else if(state.teamOk){
      top=`<p class="cam__meyebrow">Partida de práctica</p><h2 id="${ID}">¡Bien visto! ${esc(label(target))}</h2><p>Las partidas de práctica no suman premio. El descuento es para la camiseta del día.</p>`;
    } else {
      top=`<p class="cam__meyebrow">${MAX} intentos gastados</p><h2 id="${ID}">Esta vez no. Era la del ${esc(label(target))}</h2>`+(mode==="daily"&&J?J.prizeBox("camiseta",false):"<p>Prueba con otra o vuelve a la camiseta del día.</p>");
    }
    mbody.innerHTML=top+heroHTML()+(mode==="daily"?`<div class="cam__row"><button class="cam__btn cam__btn--ghost" type="button" data-share>Copiar resultado</button></div>`:"")+relatedHTML();
    const sb=mbody.querySelector("[data-share]");
    if(sb) sb.addEventListener("click",()=>{const t=shareText();(navigator.clipboard?navigator.clipboard.writeText(t):Promise.reject()).then(()=>{sb.textContent="Copiado"}).catch(()=>{sb.textContent="No se pudo copiar"})});
  }
  function renderResult(){
    const R=$("[data-result]");
    if(!state.done){R.hidden=true;R.innerHTML="";return}
    R.hidden=false;
    const lbl=mode!=="daily"?"Ver resultado":"Ver resultado y premio";
    R.innerHTML=`<p>${state.teamOk?(pleno()?"Pleno":"Acertado"):"Era"}: <b>${esc(label(target))}</b>. ${mode==="daily"?"Mañana, camiseta nueva.":""}</p><div class="cam__row"><button class="cam__btn" type="button" data-reopen>${lbl}</button>${mode!=="daily"?`<button class="cam__btn cam__btn--ghost" type="button" data-back>Volver a la del día</button>`:""}</div>`;
    R.querySelector("[data-reopen]").addEventListener("click",()=>withProduct(target).then(openModal));
    const b=R.querySelector("[data-back]");if(b)b.addEventListener("click",()=>{mode="daily";load();});
  }
  $("[data-practice]").addEventListener("click",()=>{
    mode="practice";const cur=target;let t;do{t=S[Math.floor(Math.random()*S.length)]}while(t===cur&&S.length>1);
    target=t;state={g:[],teamOk:false,pick:null,done:false,claimed:false};
    render();withProduct(target).then(()=>{if(target===t)showImage()});q.focus();root.scrollIntoView({behavior:RM?"auto":"smooth"});
  });
  load();
})();
